import React, { useEffect, useState } from "react";
import { Container, Navbar, Nav, NavDropdown } from "react-bootstrap";
import { NavLink, useNavigate } from "react-router-dom";
import "./header.css";
import Logo from "../../../assets/images/logo.png";
import Logo1 from "../../../assets/images/logo1.png";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [sticky, setSticky] = useState(false);
  const isLoggedIn = localStorage.getItem("isLoggedIn");
  const navigate = useNavigate();
  const [eventMenuOpen, setEventMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const closeMenu = () => setMenuOpen(false);

  const handleLogout = () => {
    localStorage.removeItem("isLoggedIn");
    navigate("/login");
    closeMenu();
  };

  useEffect(() => {
    const handleScroll = () => setSticky(window.scrollY > 100);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  /** ======================
   * EVENT MANAGEMENT SUBMENU (DESKTOP ONLY)
   ====================== */
  const EventManagementMenu = () => {
    return (
      <div className="dropdown-submenu">
        <span className="dropdown-item submenu-title">
          Event Management
          <i className="bi bi-chevron-right"></i>
        </span>

        <div className="submenu-dropdown">
          <NavLink to="/events/manage-folders" className="dropdown-item">
            Manage Folders
          </NavLink>
          <NavLink to="/events/manage-images" className="dropdown-item">
            Manage Images
          </NavLink>
        </div>
      </div>
    );
  };

  return (
    <header className={`site-header ${sticky ? "header-sticky" : ""}`}>
      <Container>
        <Navbar className="navbar-wrap px-0 justify-content-between">
          {/* LOGO */}
          <Navbar.Brand>
            <NavLink to="/" className="brand-logo">
              <img
                src={sticky ? Logo : Logo1}
                alt="BR Travel"
                className="logo-img"
              />
            </NavLink>
          </Navbar.Brand>

          {/* ================= DESKTOP NAV ================= */}
          <Nav className="main-nav d-none d-lg-flex align-items-center">
            <NavLink className="nav-link" to="/">
              Home
            </NavLink>
            <NavLink className="nav-link" to="/about-us">
              About Us
            </NavLink>
            <NavLink className="nav-link" to="/benefits">
              Benefits
            </NavLink>
            <NavLink className="nav-link" to="/faq">
              FAQs
            </NavLink>
            <NavLink className="nav-link" to="/enquiry">
              Enquiry
            </NavLink>
            <NavLink className="nav-link" to="/contact">
              Contact Us
            </NavLink>
            <NavLink className="nav-link" to="/terms-conditions">
              Terms
            </NavLink>

            {!isLoggedIn ? (
              <NavLink className="nav-link login-link" to="/login">
                Login
              </NavLink>
            ) : (
              <NavDropdown
                title={
                  <span className="profile-icon">
                    <i className="bi bi-person-circle"></i>
                  </span>
                }
                align="end"
                className="admin-dropdown"
              >
                <NavDropdown.Item as={NavLink} to="/leads/contactlist">
                  Contact List
                </NavDropdown.Item>

                <NavDropdown.Item as={NavLink} to="/leads/enquirylist">
                  Enquiry List
                </NavDropdown.Item>

                <EventManagementMenu />

                <NavDropdown.Divider />

                <NavDropdown.Item onClick={handleLogout}>
                  Logout
                </NavDropdown.Item>
              </NavDropdown>
            )}
          </Nav>

          {/* ================= RIGHT ACTIONS ================= */}
          <div className="header-actions">
            {/* Desktop Call */}
            <a
              href="tel:+919650801697"
              className="primaryBtn d-none d-md-inline-flex"
            >
              <i className="bi bi-telephone-fill"></i> +91 9650801697
            </a>

            {/* ================= MOBILE PROFILE DROPDOWN ================= */}
            {isLoggedIn && (
              <NavDropdown
                title={
                  <span className="profile-icon mobile-profile-icon">
                    <i className="bi bi-person-circle"></i>
                  </span>
                }
                align="end"
                className="admin-dropdown d-lg-none"
              >
                <NavDropdown.Item
                  as={NavLink}
                  to="/leads/contactlist"
                  onClick={closeMenu}
                >
                  Contact List
                </NavDropdown.Item>

                <NavDropdown.Item
                  as={NavLink}
                  to="/leads/enquirylist"
                  onClick={closeMenu}
                >
                  Enquiry List
                </NavDropdown.Item>

                <NavDropdown.Item
                  as={NavLink}
                  to="/events/manage-folders"
                  onClick={closeMenu}
                >
                  Manage Folders
                </NavDropdown.Item>

                <NavDropdown.Item
                  as={NavLink}
                  to="/events/manage-images"
                  onClick={closeMenu}
                >
                  Manage Images
                </NavDropdown.Item>
              </NavDropdown>
            )}

            {/* Hamburger */}
            <button className="menu-toggle d-lg-none" onClick={toggleMenu}>
              <i className={`bi ${menuOpen ? "bi-x" : "bi-list"}`}></i>
            </button>
          </div>
        </Navbar>
      </Container>

      {/* ================= MOBILE SLIDE MENU ================= */}
      <div className={`mobile-menu ${menuOpen ? "open" : ""}`}>
        <div className="mobile-menu-header">
          <img src={Logo} alt="BR Travel" className="mobile-menu-logo" />
          <button className="mobile-close-btn" onClick={closeMenu}>
            <i className="bi bi-x"></i>
          </button>
        </div>

        <Nav className="mobile-nav">
          {[
            { to: "/", label: "Home" },
            { to: "/about-us", label: "About Us" },
            { to: "/benefits", label: "Benefits" },
            { to: "/faq", label: "FAQs" },
            { to: "/enquiry", label: "Enquiry" },
            { to: "/contact", label: "Contact Us" },
            { to: "/terms-conditions", label: "Terms" },
          ].map((item) => (
            <NavLink key={item.to} to={item.to} onClick={closeMenu}>
              <span>{item.label}</span>
              <i className="bi bi-chevron-right"></i>
            </NavLink>
          ))}

          {!isLoggedIn ? (
            <NavLink to="/login" onClick={closeMenu}>
              <span>Login</span>
              <i className="bi bi-chevron-right"></i>
            </NavLink>
          ) : (
            <NavLink to="#" onClick={handleLogout}>
              <span>Logout</span>
              <i className="bi bi-box-arrow-right logout-icon"></i>
            </NavLink>
          )}

          <a href="tel:+919650801697" className="mobile-call-btn">
            <i className="bi bi-telephone-fill"></i> +91 9650801697
          </a>
        </Nav>
      </div>
    </header>
  );
};

export default Header;
